import { UserManager } from 'oidc-client';

const oidcSettings = {
  authority: process.env.VUE_APP_ALERTA_UI_AUTH_AUTHORITY,
  client_id: process.env.VUE_APP_ALERTA_UI_AUTH_CLIENTID,
  popup_redirect_uri: `${window.location.origin}/popup-signin-redirect`,
  popup_post_logout_redirect_uri: `${window.location.origin}/popup-signout-redirect`,
  response_type: 'code',
  response_mode: 'query',
  scope: 'profile'
}

export default new UserManager(oidcSettings);